<template>
  <div>
    <div class="header">
      <div class="switch-data-type">
        <div v-for="type, index in data_types" :key="index" class="switch-btn" @click="switchDataType(type)"
          :class="{ 'selected': picked_type === type }">
          {{ dataTypeFormat(type) }}
        </div>
      </div>
    </div>
    <canvas ref="realtimeChart"></canvas>


    <!--    <div class="card-header navbar">
      <div class="pt-1">
        <i class="fas fa-chart-bar me-1"></i>
        <span class="h5">即時監控</span>
      </div>
      <ul class="nav nav-tabs card-header-tabs">
        <li class="nav-item">
          <a class="nav-link active" v-if="picked_type == 'current'" style="color: black">電流</a>
          <a class="nav-link" v-if="picked_type == 'power'" style="color: black" href="#"
            v-on:click="switchDataTypeOld('current')">電流</a>
        </li>
        <li class="nav-item">
          <a class="nav-link active" v-if="picked_type == 'power'" style="color: black">功率</a>
          <a class="nav-link" v-if="picked_type == 'current'" style="color: black" href="#"
            v-on:click="switchDataTypeOld('power')">功率</a>
        </li>
      </ul>
    </div>
    <div class="card-body">

      <div style="height: 30vh; width: 100%">
        <canvas id="realtimeChart"></canvas>
      </div>
    </div> -->
  </div>
</template>

<script>

import { chartMixin } from './mixins/chartMixin';
import realtimeChart from "../library/realtimeChart";
import { axiosMixins } from './mixins/axiosErrorMessage';

export default {
  mixins: [axiosMixins, chartMixin],
  data() {
    return {
      realtime_data: '',
      data_types: ["power", "current"],
      picked_type: "power",
      timer: null,
      // chartMixin
      realtimeChartInstance: null,
      realtimeCtx: null,
    };
  },
  computed: {
    meter() {
      return this.$store.getters.selectedMeter
    },
    scaleColors() {
      return this.$store.getters.scaleColors
    },
  },
  watch: {
    meter(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getRealtimeData();
      }
    }
  },
  mounted() {
    this.realtimeCtx = this.$refs.realtimeChart;
  },
  methods: {
    setTimer() {
      clearInterval(this.timer);
      this.timer = null;
      this.timer = setInterval(() => {
        this.getRealtimeData()
      }, 30000);
    },
    getRealtimeData() {
      axios.post(base_url + "/api/bx/realtimeData", {
        mac: this.meter.bx_mac,
      }).then((response) => {
        this.realtime_data = response.data.latest_data;
        // this.dataFormat(response.data.latest_data);
        this.initChart();

      }).catch(error => this.axiosMessage(error));
      this.setTimer();
    },
    initChart() {
      this.destroyChart();
      this.renderChart();
    },
    destroyChart() {
      if (this.realtimeChartInstance) {
        this.barChartDatasets = [];
        this.realtimeChartInstance.destroy()
      }
    },
    renderChart() {
      let power = [];
      let current = [];
      let realtimeDatasets = {};
      let dataType = this.picked_type;
      let barColor = [];
      let barChartLabels = [];

      // 將各線路的值進行加總
      this.meter.bx_circuits.forEach((circuit, index) => {
        current.push(this.calculateSum(circuit.channels, JSON.parse(this.realtime_data.i), "i"));
        power.push(this.calculateSum(circuit.channels, JSON.parse(this.realtime_data.p), "p"));
        barColor.push(this.RGBformat(this.scaleColors[index]))
        barChartLabels.push(circuit.alias);
      });

      let commonSetup = {
        label: dataType == "current" ? "Ampere" : "kWatt",
        backgroundColor: barColor,
        borderWidth: 1,
        data: dataType == "current" ? current : power,
      }

      this.barChartDatasets.push(Object.assign(realtimeDatasets, commonSetup));
      this.barChartLabels = barChartLabels;

      this.realtimeChartInstance = new Chart(this.realtimeCtx, this.barChartConfig);
    },
    // dataFormat(bx_data) {
    //   this.current = [];
    //   this.power = [];
    //   this.meter.bx_circuits.forEach((circuit) => {
    //     this.current.push(this.calculateSum(circuit.channels, JSON.parse(bx_data.i), "i"));
    //     this.power.push(this.calculateSum(circuit.channels, JSON.parse(bx_data.p), "p"));
    //   });
    //   realtimeChart(
    //     this.current,
    //     this.power,
    //     this.meter.bx_circuits,
    //     this.picked_type,
    //     bx_data
    //   );
    // },
    calculateSum(channels, data, string) {
      const channelList = channels.split(',');
      let sum = 0;
      channelList.forEach(channel => {
        const key = string.toUpperCase() + channel[0] + (Number(channel[1]) - 1);
        sum += parseFloat(data[key]) * 1000000;
      });
      return sum / 1000000;
    },
    // switchDataTypeOld(type) {
    //   this.picked_type = type;
    //   realtimeChart(
    //     this.current,
    //     this.power,
    //     this.meter.bx_circuits,
    //     this.picked_type,
    //     null
    //   );
    // },
    switchDataType(type) {
      this.picked_type = type;
      this.initChart();
    },
    dataTypeFormat(type) {
      switch (type) {
        case "current":
          return "即時電流"
        default:
          return "即時功率"
      }
    },
  },
  beforeDestroy() {
    this.destroyChart();
  }
}
</script>

<style scoped>
.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 3px;

  .switch-btn {
    cursor: pointer;
    background-color: var(--bx-unselected-btn);
    font-size: .7rem;
    font-weight: bolder;
    width: 4rem;
    line-height: 1.8rem;
    text-align: center;
  }

  .switch-data-type {
    display: flex;
  }

  .selected {
    background-color: var(--bx-green);
    color: white;
    font-weight: normal;
  }
}
</style>
